import { render } from "./WarrantyStatementList.vue?vue&type=template&id=28d48a28"
import script from "./WarrantyStatementList.vue?vue&type=script&lang=js"
export * from "./WarrantyStatementList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__